export default "__VITE_ASSET__BopQ0u3h__"